import { apiClient } from '../../../ruutsApi/client'
import endpoints from '../../../ruutsApi/endpoints'
import { unwrapVoid } from '../../../ruutsApi/normalize'

// DELETE /v1/monitoring/events/:id answers with a message-only envelope { message },
// so the response body is intentionally discarded — see the PR 8 mutation response-shape table.
export const removeMonitoringEvent = async ({ eventId }: { eventId: string }): Promise<void> => {
  const response = await apiClient.delete(`${endpoints.events}/${eventId}`)
  return unwrapVoid(response)
}
